module.exports = __webpack_public_path__ + "fonts/Inter-300-greek21.3a3cf1a.woff2";